/** Lock G: `1 + 0.05 * min(streakAfter, 10)` → max 1.5× at streak 10. */
export function computeQuizExpStreakMultiplier(streakAfter: number): number {
	const streak = Math.max(0, Math.floor(streakAfter));
	return 1 + 0.05 * Math.min(streak, 10);
}

export function nextQuizStreakAfterGrade(params: {
	prevStreak: number;
	outcome: "correct" | "partial" | "incorrect";
}): number {
	const prev = Math.max(0, Math.floor(params.prevStreak));
	if (params.outcome === "correct") {
		return prev + 1;
	}
	if (params.outcome === "incorrect") {
		return 0;
	}
	return prev;
}
